module.exports = __webpack_public_path__ + "static/media/main.50ae2edf.png";